import config from "../config";
import store from "../app/store";
import { validJSON } from "../common/utils";
import { showToast } from "../components/Toast/toast.slice";

const deleteIndividualInvoice = async (
  id: any,
  projectId: any
): Promise<any> => {
  const myHeaders = new Headers();
  myHeaders.append("content-type", "application/json");
  myHeaders.append("authorization", `${localStorage.userAccessToken}`);

  const requestOptions = {
    method: "DELETE",
    headers: myHeaders,
  };

  const url = `${
    config[config.env].apiEnspoints.accounts
  }/invoice/deleteIndividualInvoice/${id}/${projectId}`;

  return new Promise((resolve, reject) => {
    fetch(url, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        if (validJSON(result)) {
          const destroyResponse = JSON.parse(result);
          if (destroyResponse.statusCode === 200 && destroyResponse.success) {
            resolve(destroyResponse);
          } else {
            throw destroyResponse.error;
          }
        } else {
          const errorResponse = {
            error: "Error",
            message: "Invalid Response JSON Format",
            code: "Invalid JSON",
          };
          throw errorResponse;
        }
      })
      .catch((error: any) => {
        store.dispatch(showToast(error));
        reject(error);
      });
  });
};
export default deleteIndividualInvoice;
